export const CLASSROOM_TEACHER_SCOPES = [
	"https://www.googleapis.com/auth/classroom.courses.readonly",
	"https://www.googleapis.com/auth/classroom.announcements",
	"https://www.googleapis.com/auth/classroom.courseworkmaterials",
	"https://www.googleapis.com/auth/classroom.coursework.students",
	"https://www.googleapis.com/auth/classroom.rosters",
	"https://www.googleapis.com/auth/classroom.profile.emails",
];

export const CLASSROOM_STUDENT_SCOPES = [
	// "https://www.googleapis.com/auth/classroom.rosters",
	"https://www.googleapis.com/auth/classroom.coursework.me",
];
